import React from "react";
import { migrationMetrics, migrationRows } from "../../data/hrTechnology";
import { Exhibit } from "../Exhibit";
import { SectionLabel } from "../SectionLabel";
export function SystemStateComparison() {
  return <section aria-labelledby="system-state-title" className="bg-stone/40" data-id="element-280" data-mp="1oi2zzjwitx8v">
      <div className="shell py-24 md:py-32" data-id="element-281" data-mp="1jjhyzi9g39jd">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-14" data-id="element-282" data-mp="1jktdod4fi1p9">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-283" data-mp="vtnp99kfa13c">
            <SectionLabel data-id="element-284" data-mp="qvcd2s6nnehy">Before and after</SectionLabel>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-285" data-mp="qx6wu366x0kg">
            <h2 id="system-state-title" className="font-display text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.05] text-navy" data-id="element-286" data-mp="14vdpn4wa8ad9">
              What changes when the systems are set up properly.
            </h2>
            <p className="mt-6 max-w-xl leading-relaxed text-charcoal/75" data-id="element-287" data-mp="2g993mabgad2w">
              Fewer hands on the data. Fewer spreadsheets in between. Every handoff owned and checked.
            </p>
          </div>
        </div>

        <Exhibit label="Exhibit — System state" title="Handoffs before and after a Constant engagement" source="Illustrative composite of a mid-size, multi-state employer. Representative, not a specific client." data-id="element-288" data-mp="3q0cfe0xsx7mx">
          <div className="overflow-x-auto" data-id="element-289" data-mp="7uzjiqeyukfr">
            <table className="w-full min-w-[640px] text-left" data-id="element-290" data-mp="7uppmrqsvt4s">
              <thead data-id="element-291" data-mp="37b5ty65mi1xf">
                <tr className="border-b border-navy" data-id="element-292" data-mp="37bnxlnum7ifd">
                  <th scope="col" className="eyebrow w-[28%] pb-3 pr-6 font-semibold text-charcoal/60" data-id="element-293" data-mp="3bboow92tbo3u">
                    Handoff
                  </th>
                  <th scope="col" className="eyebrow pb-3 pr-6 font-semibold text-charcoal/60" data-id="element-294" data-mp="3g9hvv4bxwm56">
                    Before
                  </th>
                  <th scope="col" className="eyebrow pb-3 font-semibold text-oxblood" data-id="element-295" data-mp="2nmna843dzgq4">
                    After
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-296" data-mp="2sj3z50ietz49">
                {migrationRows.map(r => <tr key={r.handoff} className="border-b border-stone" data-id="element-297" data-mp="3vut7kexgy6se">
                    <th scope="row" className="py-4 pr-6 font-display text-lg font-normal text-navy" data-id="element-298" data-mp="3qy2s9tthnf81">
                      {r.handoff}
                    </th>
                    <td className="py-4 pr-6 text-[15px] text-charcoal/60" data-id="element-299" data-mp="8l4qdhd4ycb8">
                      <span className="flex items-center gap-3" data-id="element-300" data-mp="4ii0vn3xt3h7">
                        <span aria-hidden className="block h-2 w-2 shrink-0 border border-charcoal/40" data-id="element-301" data-mp="3cyjlp5gbsbxu" />
                        {r.before}
                      </span>
                    </td>
                    <td className="py-4 text-[15px] text-navy" data-id="element-302" data-mp="3lygdhfy0hqx4">
                      <span className="flex items-center gap-3" data-id="element-303" data-mp="3gz3gw3hc95hc">
                        <span aria-hidden className="block h-2 w-2 shrink-0 bg-navy" data-id="element-304" data-mp="3gxk44muw5ckb" />
                        {r.after}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <dl className="mt-12 grid grid-cols-1 border-t border-navy sm:grid-cols-3" data-id="element-305" data-mp="14pn3gb2t0bya">
            {migrationMetrics.map((m, i) => <div key={m.label} className={`py-6 ${i > 0 ? "border-t border-stone sm:border-l sm:border-t-0 sm:pl-8" : ""}`} data-id="element-306" data-mp="18stc1pde2f7x" data-mpi={i}>
                <dt className="text-sm text-charcoal/70" data-id="element-307" data-mp="zqsfkupzbx7b">{m.label}</dt>
                <dd className="mt-3 flex items-baseline gap-4" data-id="element-308" data-mp="zr24sg37a0by">
                  <span className="font-display text-3xl tabular-nums text-charcoal/40 line-through decoration-oxblood decoration-1" data-id="element-309" data-mp="1nhfn3evzgktc">
                    {m.before}
                  </span>
                  <span className="font-display text-6xl leading-none tabular-nums text-navy" data-id="element-310" data-mp="1drcxzprzfr0a">{m.after}</span>
                  <span className="sr-only" data-id="element-311" data-mp="1iomkoxnzlokf">
                    Before {m.before}, after {m.after}
                  </span>
                </dd>
              </div>)}
          </dl>
        </Exhibit>
      </div>
    </section>;
}